<template>
  <div class="help padding_top">
    <p><strong>【查看结账单】</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>，即可进入【医生工作室】，在顶部菜单栏中点击<span
        class="orange">【结账单】</span></p>
    <img src="../../../assets/doctorImg/statement_a.png" alt="">
    <p>【已结清】平台已将费用支付给医生<br/>
      【未结清】平台未将费用支付给医生，提交结账单之后48h之内进行结算<br/>
      【详情】点击列表中的<span class="orange">【详情】</span>按钮，可查看已结清的支付详情信息<br/>
    </p>
    <p><strong>【预约结账单】</strong>当咨询结束时，需要在【预约管理】列表中点击<span class="orange">【结束】</span>按钮，确认完成咨询，该预约项才会显示在结账单中，平台将会在48h之内为医生结算
    </p>
    <img src="../../../assets/doctorImg/statement_b.png" alt="">
    <p><strong>【月卡/年卡结账单】</strong>当用户购买了医生专属的月卡或年卡时，用户每使用一次，平台进行结算一次的费用金额<br/>
      月卡/年卡到期之后，平台会将剩余未使用金额一次性结算给医生
    </p>
  </div>

</template>

<script>
export default {
  name: "statement",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
